/* eslint-disable max-len */
import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { useHistory, useParams } from 'react-router-dom';

import DashboardWrap from '../../components/DashboardWrap';
import EmptyPageLoader from '../../components/EmptyPageLoader';
import UserDetailsCardCa from '../../components/UserDetailsCardCa';
import { GET_ADMIN_SINGLE_BILLS_PAYMENT } from '../../graphql/admin_queries';
import { cleanSingleBillsPaymentRecord } from '../../utils/helpers';

import { BillsPaymentDetailsCard } from './_partials';
import RolesAndPermissionGuard from '../../components/RolesAndPermissionGuard';

import GoBackIcon from '../../svgs/GoBackIcon';

import styles from './BillsPaymentDetails.module.scss';
import PermissionDenied from '../PermissionDenied';

const BillsPaymentDetails = () => {
  const history = useHistory();

  const { billPaymentId } = useParams<{ billPaymentId: string }>();

  const { data, loading } = useQuery<
    {
      getOneBillPaymentsAdminCa: any;
    },
    { billPaymentId: string }
  >(GET_ADMIN_SINGLE_BILLS_PAYMENT, { variables: { billPaymentId } });

  const rentPayment = useMemo(() => data?.getOneBillPaymentsAdminCa, [data]);
  const payload = cleanSingleBillsPaymentRecord(rentPayment);

  const statusClass = (status:string) => {
    switch (status) {
    case 'success':
      return styles.wrapper__success;
    case 'pending':
      return styles.wrapper__pending;

    default:
      return styles.wrapper__failed;
    }
  };

  return (
    <DashboardWrap className={styles.billsPaymentDetailsLayout}>
      {
        loading ? <EmptyPageLoader /> : (
          <RolesAndPermissionGuard permissionName="can-get-bills-payment" hasErrorTemplate={<PermissionDenied height="60vh" />}>
            <div className={styles.wrapper}>
              <div className={styles.wrapper__top}>
                <div className={styles.wrapper__titleContainer}>
                  <GoBackIcon onClick={() => history?.goBack()} />
                  Bills payment
                </div>
                <UserDetailsCardCa payload={payload}>
                  <span className={statusClass(payload?.status)}>{payload?.status}</span>
                </UserDetailsCardCa>
                <BillsPaymentDetailsCard
                  payload={payload}
                />
              </div>

            </div>
          </RolesAndPermissionGuard>

        )
      }
    </DashboardWrap>
  );
};

export default BillsPaymentDetails;
